var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container leader-jobs-page" },
    [
      _c(
        "div",
        { staticClass: "page-heading" },
        [
          _c(
            "div",
            { staticClass: "page-title" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-back" },
                  on: { click: _vm.backToHunter },
                },
                [_vm._v("返回尋找領隊")]
              ),
              _vm._m(0),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                icon: "el-icon-plus",
                disabled: _vm.featureDisabled,
              },
              on: {
                click: function ($event) {
                  return _vm.openEditor()
                },
              },
            },
            [_vm._v(" 新增徵才 ")]
          ),
        ],
        1
      ),
      _vm.featureDisabled
        ? _c("el-alert", {
            staticClass: "load-alert",
            attrs: {
              type: "warning",
              title: "專區已關閉",
              description:
                "領隊導遊專區目前已關閉，新增、狀態變更等寫操作已停用；如需開放，請聯絡系統管理員。",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: true, model: _vm.query },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "關鍵字" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      maxlength: "100",
                      placeholder: "標題、摘要",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.search($event)
                      },
                    },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keyword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _vm.isContentAdmin
                ? _c(
                    "el-form-item",
                    { attrs: { label: "發布單位" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "全部旅行社",
                          },
                          model: {
                            value: _vm.query.agencyCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.query, "agencyCode", $$v)
                            },
                            expression: "query.agencyCode",
                          },
                        },
                        _vm._l(_vm.agencyOptions, function (agency) {
                          return _c("el-option", {
                            key: agency.key,
                            attrs: { label: agency.val, value: agency.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "身分" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.roleType,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "roleType", $$v)
                        },
                        expression: "query.roleType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "領隊", value: "Leader" },
                      }),
                      _c("el-option", {
                        attrs: { label: "導遊", value: "Guide" },
                      }),
                      _c("el-option", {
                        attrs: { label: "皆可", value: "Both" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分類" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", maxlength: "100" },
                    model: {
                      value: _vm.query.category,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "category",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.category",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "目的地" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", maxlength: "200" },
                    model: {
                      value: _vm.query.destination,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "destination",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.destination",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工作開始" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      clearable: "",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "開始日",
                    },
                    model: {
                      value: _vm.query.startDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "startDate", $$v)
                      },
                      expression: "query.startDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工作結束" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      clearable: "",
                      "value-format": "yyyy-MM-dd",
                      placeholder: "結束日",
                    },
                    model: {
                      value: _vm.query.endDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "endDate", $$v)
                      },
                      expression: "query.endDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "狀態" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (option) {
                      return _c("el-option", {
                        key: option.value,
                        attrs: { label: option.label, value: option.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.query.sort,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "sort", $$v)
                        },
                        expression: "query.sort",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "最新建立", value: "latest" },
                      }),
                      _c("el-option", {
                        attrs: { label: "推薦優先", value: "recommended" },
                      }),
                      _c("el-option", {
                        attrs: { label: "截止日期", value: "deadline" },
                      }),
                      _c("el-option", {
                        attrs: { label: "工作日期", value: "startDate" },
                      }),
                      _c("el-option", {
                        attrs: { label: "薪資由高至低", value: "salaryDesc" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v(" 查詢 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", disabled: _vm.loading },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重設")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.loadError
        ? _c("el-alert", {
            staticClass: "load-alert",
            attrs: {
              type: "error",
              title: _vm.loadError,
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.jobs,
            border: "",
            stripe: "",
            "empty-text": "尚無徵才啟事",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: "標題",
              "min-width": "220",
              "show-overflow-tooltip": "",
            },
          }),
          _vm.isContentAdmin
            ? _c("el-table-column", {
                attrs: {
                  prop: "agencyName",
                  label: "發布單位",
                  "min-width": "160",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "身分", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.roleLabel(scope.row.roleType)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "destination",
              label: "目的地",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "工作日期", "min-width": "190" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.dateRange(scope.row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "薪資", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.compensationLabel(scope.row)))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "應徵", width: "90", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.applicationCount || 0) +
                        " / " +
                        _vm._s(scope.row.quota) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.isContentAdmin
            ? _c("el-table-column", {
                attrs: { label: "推薦", width: "90", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              value: scope.row.isRecommended,
                              disabled:
                                _vm.isRowUpdating(scope.row.id) ||
                                scope.row.status === "Closed" ||
                                _vm.featureDisabled,
                              "aria-label": scope.row.title + "推薦開關",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateRecommendation(
                                  scope.row,
                                  $event
                                )
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2584678734
                ),
              })
            : _vm._e(),
          _vm.isContentAdmin
            ? _c("el-table-column", {
                attrs: { label: "推薦排序", width: "130", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input-number", {
                            attrs: {
                              value: scope.row.recommendSort,
                              min: 0,
                              max: 9999,
                              size: "mini",
                              "controls-position": "right",
                              disabled:
                                _vm.isRowUpdating(scope.row.id) ||
                                scope.row.status === "Closed" ||
                                _vm.featureDisabled,
                              "aria-label": scope.row.title + "推薦排序",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateRecommendSort(
                                  scope.row,
                                  $event
                                )
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1080562816
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "狀態", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.statusTagType(scope.row.status) } },
                      [_vm._v(_vm._s(_vm.jobStatusLabel(scope.row.status)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "450",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.openPreview(scope.row)
                          },
                        },
                      },
                      [_vm._v("預覽")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          disabled:
                            scope.row.status === "Closed" ||
                            _vm.featureDisabled,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openEditor(scope.row)
                          },
                        },
                      },
                      [_vm._v(" 編輯 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", disabled: _vm.featureDisabled },
                        on: {
                          click: function ($event) {
                            return _vm.copyJob(scope.row)
                          },
                        },
                      },
                      [_vm._v(" 複製 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "info" },
                        on: {
                          click: function ($event) {
                            return _vm.openApplications(scope.row)
                          },
                        },
                      },
                      [_vm._v(" 應徵者 ")]
                    ),
                    scope.row.status !== "Published" &&
                    scope.row.status !== "Closed"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "success",
                              disabled: _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(scope.row, "Published")
                              },
                            },
                          },
                          [_vm._v(" 發布 ")]
                        )
                      : _vm._e(),
                    scope.row.status === "Published"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              disabled: _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(
                                  scope.row,
                                  "Unpublished"
                                )
                              },
                            },
                          },
                          [_vm._v(" 下架 ")]
                        )
                      : _vm._e(),
                    scope.row.status !== "Closed"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              plain: "",
                              disabled: _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeStatus(scope.row, "Closed")
                              },
                            },
                          },
                          [_vm._v(" 結束 ")]
                        )
                      : _vm._e(),
                    scope.row.status === "Draft" ||
                    scope.row.status === "Unpublished"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              disabled: _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteJob(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 刪除 ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.query.page,
          limit: _vm.query.pageSize,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.query, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.query, "pageSize", $event)
          },
          pagination: _vm.fetchJobs,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editingJob.id ? "編輯徵才啟事" : "新增徵才啟事",
            visible: _vm.editorVisible,
            width: "820px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editorVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "jobForm",
              attrs: {
                model: _vm.editingJob,
                rules: _vm.rules,
                "label-width": "110px",
              },
            },
            [
              _vm.isContentAdmin && !_vm.editingJob.id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "發布單位", prop: "targetAgencyCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            placeholder: "請選擇旅行社",
                          },
                          model: {
                            value: _vm.editingJob.targetAgencyCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.editingJob, "targetAgencyCode", $$v)
                            },
                            expression: "editingJob.targetAgencyCode",
                          },
                        },
                        _vm._l(_vm.agencyOptions, function (agency) {
                          return _c("el-option", {
                            key: agency.key,
                            attrs: { label: agency.val, value: agency.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm.editingJob.id
                ? _c(
                    "el-form-item",
                    { attrs: { label: "發布單位" } },
                    [
                      _c("el-input", {
                        attrs: {
                          value: _vm.editingJob.agencyName || "由伺服器識別",
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "el-form-item",
                    { attrs: { label: "發布單位" } },
                    [
                      _c("el-input", {
                        attrs: { value: "依登入旅行社自動帶入", disabled: "" },
                      }),
                    ],
                    1
                  ),
              _c(
                "el-form-item",
                { attrs: { label: "標題", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200", "show-word-limit": "" },
                    model: {
                      value: _vm.editingJob.title,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingJob,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingJob.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "身分", prop: "roleType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.editingJob.roleType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.editingJob, "roleType", $$v)
                                },
                                expression: "editingJob.roleType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "領隊", value: "Leader" },
                              }),
                              _c("el-option", {
                                attrs: { label: "導遊", value: "Guide" },
                              }),
                              _c("el-option", {
                                attrs: { label: "皆可", value: "Both" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "分類", prop: "category" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "100" },
                            model: {
                              value: _vm.editingJob.category,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingJob,
                                  "category",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingJob.category",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "目的地", prop: "destination" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "200" },
                            model: {
                              value: _vm.editingJob.destination,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingJob,
                                  "destination",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "editingJob.destination",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "集合地", prop: "meetingPlace" } },
                [
                  _c("el-input", {
                    attrs: { maxlength: "200" },
                    model: {
                      value: _vm.editingJob.meetingPlace,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingJob,
                          "meetingPlace",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingJob.meetingPlace",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "開始日", prop: "startDate" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { "value-format": "yyyy-MM-dd" },
                            model: {
                              value: _vm.editingJob.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingJob, "startDate", $$v)
                              },
                              expression: "editingJob.startDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "結束日", prop: "endDate" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { "value-format": "yyyy-MM-dd" },
                            model: {
                              value: _vm.editingJob.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingJob, "endDate", $$v)
                              },
                              expression: "editingJob.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "截止日",
                            prop: "applicationDeadline",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { "value-format": "yyyy-MM-dd" },
                            model: {
                              value: _vm.editingJob.applicationDeadline,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.editingJob,
                                  "applicationDeadline",
                                  $$v
                                )
                              },
                              expression: "editingJob.applicationDeadline",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "名額", prop: "quota" } },
                        [
                          _c("el-input-number", {
                            attrs: { min: 1, max: 999 },
                            model: {
                              value: _vm.editingJob.quota,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingJob, "quota", $$v)
                              },
                              expression: "editingJob.quota",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "薪資", prop: "salaryAmount" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 9999999999.99,
                              precision: 2,
                              disabled:
                                _vm.editingJob.compensationType ===
                                "Negotiable",
                            },
                            model: {
                              value: _vm.editingJob.salaryAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.editingJob, "salaryAmount", $$v)
                              },
                              expression: "editingJob.salaryAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "計價方式",
                            prop: "compensationType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              on: { change: _vm.handleCompensationTypeChange },
                              model: {
                                value: _vm.editingJob.compensationType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editingJob,
                                    "compensationType",
                                    $$v
                                  )
                                },
                                expression: "editingJob.compensationType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "總額", value: "Total" },
                              }),
                              _c("el-option", {
                                attrs: { label: "日薪", value: "PerDay" },
                              }),
                              _c("el-option", {
                                attrs: { label: "面議", value: "Negotiable" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "幣別", prop: "currency" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { filterable: "" },
                      model: {
                        value: _vm.editingJob.currency,
                        callback: function ($$v) {
                          _vm.$set(_vm.editingJob, "currency", $$v)
                        },
                        expression: "editingJob.currency",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "TWD", value: "TWD" },
                      }),
                      _c("el-option", {
                        attrs: { label: "JPY", value: "JPY" },
                      }),
                      _c("el-option", {
                        attrs: { label: "USD", value: "USD" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "標籤" } },
                [
                  _c("el-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      "default-first-option": "",
                      placeholder: "最多 10 個標籤",
                    },
                    model: {
                      value: _vm.editingJob.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.editingJob, "tags", $$v)
                      },
                      expression: "editingJob.tags",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "摘要", prop: "summary" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingJob.summary,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingJob,
                          "summary",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingJob.summary",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工作內容", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "4000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingJob.description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingJob,
                          "description",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingJob.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "應徵條件", prop: "requirements" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "4000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.editingJob.requirements,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.editingJob,
                          "requirements",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "editingJob.requirements",
                    },
                  }),
                ],
                1
              ),
              _vm.isContentAdmin
                ? _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "推薦" } },
                            [
                              _c("el-switch", {
                                model: {
                                  value: _vm.editingJob.isRecommended,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editingJob,
                                      "isRecommended",
                                      $$v
                                    )
                                  },
                                  expression: "editingJob.isRecommended",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "推薦排序" } },
                            [
                              _c("el-input-number", {
                                attrs: { min: 0, max: 999999 },
                                model: {
                                  value: _vm.editingJob.recommendSort,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editingJob,
                                      "recommendSort",
                                      $$v
                                    )
                                  },
                                  expression: "editingJob.recommendSort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.openPreview(_vm.editingJob)
                    },
                  },
                },
                [_vm._v("預覽")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editorVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.saving,
                    disabled: _vm.featureDisabled,
                  },
                  on: { click: _vm.saveJob },
                },
                [_vm._v(" 儲存 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "徵才預覽",
            visible: _vm.previewVisible,
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _vm.previewJob
            ? _c(
                "article",
                { staticClass: "job-preview" },
                [
                  _c("div", { staticClass: "preview-heading" }, [
                    _c(
                      "div",
                      [
                        _c("el-tag", { attrs: { size: "small" } }, [
                          _vm._v(
                            _vm._s(_vm.roleLabel(_vm.previewJob.roleType))
                          ),
                        ]),
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.previewJob.title || "尚未填寫標題")
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.previewJob.agencyName ||
                                _vm.selectedAgencyName ||
                                "發布旅行社"
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.compensationLabel(_vm.previewJob))),
                    ]),
                  ]),
                  _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "目的地" } },
                        [_vm._v(_vm._s(_vm.previewJob.destination || "未設定"))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "集合地" } },
                        [
                          _vm._v(
                            _vm._s(_vm.previewJob.meetingPlace || "未設定")
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "工作日期" } },
                        [_vm._v(_vm._s(_vm.dateRange(_vm.previewJob)))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "應徵截止" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.previewJob.applicationDeadline || "未設定"
                            )
                          ),
                        ]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "名額" } }, [
                        _vm._v(_vm._s(_vm.previewJob.quota || 1) + " 名"),
                      ]),
                      _c("el-descriptions-item", { attrs: { label: "分類" } }, [
                        _vm._v(_vm._s(_vm.previewJob.category || "未設定")),
                      ]),
                    ],
                    1
                  ),
                  _c("section", [
                    _c("h3", [_vm._v("摘要")]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.previewJob.summary || "未填寫")),
                    ]),
                  ]),
                  _c("section", [
                    _c("h3", [_vm._v("工作內容")]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.previewJob.description || "未填寫")),
                    ]),
                  ]),
                  _c("section", [
                    _c("h3", [_vm._v("應徵條件")]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.previewJob.requirements || "未填寫")),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "preview-tags" },
                    _vm._l(_vm.previewJob.tags, function (tag) {
                      return _c(
                        "el-tag",
                        { key: tag, attrs: { size: "small", type: "info" } },
                        [_vm._v(" " + _vm._s(tag) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "應徵者",
            visible: _vm.applicationsVisible,
            width: "960px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.applicationsVisible = $event
            },
          },
        },
        [
          _vm.selectedJob
            ? _c("p", { staticClass: "dialog-caption" }, [
                _vm._v(_vm._s(_vm.selectedJob.title)),
              ])
            : _vm._e(),
          _vm.applicationsError
            ? _c("el-alert", {
                attrs: {
                  type: "error",
                  title: _vm.applicationsError,
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.applicationsLoading,
                  expression: "applicationsLoading",
                },
              ],
              attrs: { data: _vm.applications, "empty-text": "尚無應徵資料" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "applicantName",
                  label: "姓名",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "身分", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.roleLabel(scope.row.roleType)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "appliedAt",
                  label: "應徵時間",
                  "min-width": "170",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "狀態", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: _vm.normalizeApplicationStatus(
                                scope.row.status
                              ),
                              size: "mini",
                              disabled:
                                _vm.isApplicationUpdating(scope.row.id) ||
                                ["Accepted", "Rejected", "Cancelled"].includes(
                                  scope.row.status
                                ) ||
                                _vm.featureDisabled,
                              "aria-label":
                                (scope.row.applicantName || "應徵者") +
                                "應徵狀態",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateApplicationStatus(
                                  scope.row,
                                  $event
                                )
                              },
                            },
                          },
                          _vm._l(
                            _vm.applicationStatusOptions,
                            function (option) {
                              return _c("el-option", {
                                key: option.value,
                                attrs: {
                                  label: option.label,
                                  value: option.value,
                                  disabled:
                                    _vm.isApplicationStatusOptionDisabled(
                                      scope.row.status,
                                      option.value
                                    ),
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "summary",
                  label: "自我推薦",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "210", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openApplicant(scope.row, "profile")
                              },
                            },
                          },
                          [_vm._v("公開簡介")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              disabled:
                                !_vm.canContactApplication(scope.row) ||
                                _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openApplicant(scope.row, "contact")
                              },
                            },
                          },
                          [_vm._v(" 邀約 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              disabled:
                                !_vm.canContactApplication(scope.row) ||
                                _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openApplicant(scope.row, "chat")
                              },
                            },
                          },
                          [_vm._v(" 聊天室 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.applicationsTotal > 0,
                expression: "applicationsTotal > 0",
              },
            ],
            attrs: {
              total: _vm.applicationsTotal,
              page: _vm.applicationsQuery.page,
              limit: _vm.applicationsQuery.pageSize,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.applicationsQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.applicationsQuery, "pageSize", $event)
              },
              pagination: _vm.fetchApplications,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.adminContactForm.contactType === "invitation"
                ? "從應徵者建立邀約"
                : "傳送訊息給應徵者",
            visible: _vm.adminContactVisible,
            width: "640px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.adminContactVisible = $event
            },
          },
        },
        [
          _vm.adminContactApplication
            ? _c("p", { staticClass: "dialog-caption" }, [
                _vm._v(
                  " " + _vm._s(_vm.adminContactApplication.applicantName) + " "
                ),
              ])
            : _vm._e(),
          _vm.adminContactError
            ? _c("el-alert", {
                attrs: {
                  type: "error",
                  title: _vm.adminContactError,
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.adminContactLoading,
                  expression: "adminContactLoading",
                },
              ],
              ref: "adminContactForm",
              attrs: {
                model: _vm.adminContactForm,
                rules: _vm.adminContactRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旅行團", prop: "travelId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        placeholder: "請選擇此職缺旅行社的旅行團",
                      },
                      model: {
                        value: _vm.adminContactForm.travelId,
                        callback: function ($$v) {
                          _vm.$set(_vm.adminContactForm, "travelId", $$v)
                        },
                        expression: "adminContactForm.travelId",
                      },
                    },
                    _vm._l(_vm.adminContactTravels, function (travel) {
                      return _c("el-option", {
                        key: travel.id,
                        attrs: {
                          label: _vm.travelLabel(travel),
                          value: travel.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.adminContactForm.contactType === "invitation"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "邀約標題", prop: "title" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "200", "show-word-limit": "" },
                          model: {
                            value: _vm.adminContactForm.title,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.adminContactForm,
                                "title",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "adminContactForm.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "工作日期" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "range-separator": "至",
                            "start-placeholder": "開始日",
                            "end-placeholder": "結束日",
                          },
                          model: {
                            value: _vm.adminContactForm.workDates,
                            callback: function ($$v) {
                              _vm.$set(_vm.adminContactForm, "workDates", $$v)
                            },
                            expression: "adminContactForm.workDates",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "回覆期限", prop: "expiresAt" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "請選擇未來時間",
                          },
                          model: {
                            value: _vm.adminContactForm.expiresAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.adminContactForm, "expiresAt", $$v)
                            },
                            expression: "adminContactForm.expiresAt",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "內容", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "4000",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.adminContactForm.content,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.adminContactForm,
                          "content",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "adminContactForm.content",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.adminContactVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.adminContactSubmitting,
                    disabled:
                      _vm.adminContactLoading ||
                      _vm.adminContactTravels.length === 0 ||
                      _vm.featureDisabled,
                  },
                  on: { click: _vm.submitAdminContact },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.adminContactForm.contactType === "invitation"
                          ? "送出邀約"
                          : "傳送訊息"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("徵才啟事")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }